module.exports = __webpack_public_path__ + "img/OMillionaire_logo_Final11.927c043b.svg";